module.exports = __webpack_public_path__ + "img/look6.55fff77e.png";